import { HelpTextConfig } from './helptext-config';

export const testAdapterPageHelpText: Record<string, HelpTextConfig> = {
  adapterTimeout: {
    title: "Adapter Timeout",
    content: "Maximum time in seconds allowed for adapter execution. The system will consider the adapter to have timed out if a response is not received in this time.",
  },

  annotation: {
    title: "Annotation",
    content: "Technical documentation and usage examples for the adapter.",
  },

  testMode: {
    title: "Test Mode",
    content: "When enabled, the endpoint is called with the URL parameter \"test_mode=true\". This should prevent any write action if the adapter has been correctly implemented.",
  },

  inputParameters: {
    title: "Input Parameters",
    content: "Configure the input values that will be sent to your adapter in the body of the request. Reference the annotation to better understand the expected input parameters.",
  },

  results: {
    title: "Response",
    content: "The response returned by your adapter.",
  }
}; 